module.exports = __webpack_public_path__ + "static/social-events-icon-3ac5268d7e12b04810f2077e8bec9a4b.svg";